import { DateTime } from 'luxon';

export const toFormattedDate = (date) => {
  return DateTime.fromISO(date).toFormat('kkkk.LL.dd - TT');
};
